import { client } from '@api/client';

import { IItemsResponse } from '@interfaces/common/response';
import { ICrowdCellCard, ICrowdCellConfig, ICrowdCellProfile } from '@interfaces/crowdcell/crowdCells';
import { IGetCrowdCellConfigDTO, IGetCrowdCellsDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';
import { IAddSiteAndLinkDTO, ILinkCrowdCellDTO } from '@interfaces/crowdcell/dto/linkSiteDTO';

import { URL } from './urls';

const {
	crowdCells,
	linkSite,
	downloadCrowdCellConfig,
	unlinkSite,
	addSiteAndLink,
	crowdCellConfig,
	card,
	crowdCellDatesExist,
} = URL;

export const getCrowdCells = ({
	ims,
	isLinked,
	mme,
	page,
	pageSize,
	searchValue,
	searchField,
	sortDirection,
	sortFieldName,
	status,
}: Omit<IGetCrowdCellsDTO, 'organizationId'>): Promise<IItemsResponse<ICrowdCellProfile>> => client.get(`/${crowdCells}`, {
	params: {
		ims,
		isLinked,
		mme,
		page,
		pageSize,
		searchValue,
		searchField,
		sortDirection,
		sortFieldName,
		status,
	},
});

export const getCrowdCellConfig = ({
	crowdCellId,
	timestamp,
	type,
}: IGetCrowdCellConfigDTO): Promise<ICrowdCellConfig> => {
	return client.get(`/${crowdCells}/${crowdCellId}${crowdCellConfig}`, {
		params: {
			crowdCellId,
			timestamp,
			type,
		},
	});
};

export const getCrowdCellDatesExist = ({
	crowdCellId,
	type,
}: IGetCrowdCellConfigDTO): Promise<number[]> => client.get(`/${crowdCells}/${crowdCellId}${crowdCellDatesExist}`, {
	params: {
		crowdCellId,
		type,
	},
});

export const getCrowdCellCard = (id: string): Promise<ICrowdCellCard> => client.get(`/${crowdCells}/${id}${card}`);

export const unlinkCrowdCell = ({
	crowdCellId,
	siteDbId,
}: ILinkCrowdCellDTO): Promise<void> => client.post(`/${crowdCells}${unlinkSite}`, {
	crowdCellId,
	siteDbId,
});

export const linkCrowdCell = ({
	crowdCellId,
	siteDbId,
}: ILinkCrowdCellDTO): Promise<void> => client.post(`/${crowdCells}${linkSite}`, {
	crowdCellId,
	siteDbId,
});

export const createSiteAndLink = ({
	lat,
	lng,
	siteId,
	siteType,
	vendor,
	crowdCellId,
}: IAddSiteAndLinkDTO): Promise<void> => client.post(`/${crowdCells}${addSiteAndLink}`,
	{
		lat,
		lng,
		siteId,
		siteType,
		vendor,
	},
	{
		params: {
			crowdCellId,
		},
	},
);

export const exportCrowdCellConfig = ({
	crowdCellId,
	timestamp,
	type,
}: IGetCrowdCellConfigDTO): Promise<void> => client.get(`/${crowdCells}/${crowdCellId}${downloadCrowdCellConfig}`, {
	params: {
		timestamp,
		type,
	},
});
